import { Injectable, inject } from '@angular/core';
import { CategoryModel } from '../models/categories.model';
import { Observable } from 'rxjs';
import { HttpClient, HttpParams } from '@angular/common/http';
import { ApiResponse } from '@shared/models';
import { map } from 'rxjs/operators';

@Injectable({
    providedIn: 'root',
})
export class HttpService {
    private httpClient = inject(HttpClient);

    getCategories(limit: number): Observable<CategoryModel[]> {
        const params: HttpParams = new HttpParams().append('limit', limit.toString());

        return this.httpClient.get<ApiResponse<CategoryModel[]>>(`api/public/categories`, { params }).pipe(
            map((response) => response.data),
            map((categories) => {
                return categories.map((category) => {
                    if (!category.image?.url) {
                        category.image = { url: `/assets/images/products/product_${Math.floor(Math.random() * 4) + 1}.png` };
                    } else {
                        category.image.url = `${category.image.url}?x=480`;
                    }
                    return category;
                });
            }),
        );
    }
}
